import KeywordListNewListPanel from './KeywordListNewListPanel.vue';

export default KeywordListNewListPanel;
